import { PaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ComplaintInternalMessage from '../../models/ComplaintInternalMessage';


export interface ComplaintInternalMessageState extends PaginatedApiState {
  complaintInternalMessage?: ComplaintInternalMessage[]
}

export default requestReducer<ComplaintInternalMessageState>('COMPLAINT_INTERNAL_MESSAGE')
